import { Component, OnInit, ElementRef, OnDestroy, ViewChild } from '@angular/core';
import { PopupTemperaturaRoteiroService } from './popup-temperatura-roteiro.service';
import * as echarts from 'echarts';
import { NgIf } from '@angular/common';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-popup-temperatura-roteiro',
  templateUrl: './popup-temperatura-roteiro.component.html',
  styleUrl: './popup-temperatura-roteiro.component.css',
  imports: [NgIf]
})
export class PopupTemperaturaRoteiroComponent implements OnInit, OnDestroy {

  private modalElement: any;
  @ViewChild('chartContainer', { static: false }) chartContainer!: ElementRef;
  private chartInstance: any;

  constructor(private el: ElementRef, public popupTemperaturaRoteiroService: PopupTemperaturaRoteiroService) {}

ngOnInit() {
  this.modalElement = this.el.nativeElement.querySelector('#popupID-temperatura-roteiro');

  if (this.modalElement) {
    this.modalElement.addEventListener(
      'show.bs.modal',
      this.iniciarComponenteBind
    );

    this.modalElement.addEventListener(
      'hidden.bs.modal',
      this.destruirComponenteBind
    );
  }
}
  async iniciarComponente(): Promise<void> {
    setTimeout(async () => {
      window.addEventListener('resize', this.redimensionar);
      await this.popupTemperaturaRoteiroService.buscaTemperaturaRoteiro();
      this.renderizarGrafico();
    }, 100);
  }

  renderizarGrafico(): void {
    const temperaturas = this.popupTemperaturaRoteiroService.temperaturas;
    if (!temperaturas || temperaturas.length === 0) {
      return; 
    }

    if (!this.chartInstance && this.chartContainer) {
      this.chartInstance = echarts.init(this.chartContainer.nativeElement);
    }

      const dataX = temperaturas.map(t => {
        const data = new Date(t.dataCriacao.toString().replace("Z", ""));
        return data.toLocaleString('pt-BR', {
          day: '2-digit',
          month: '2-digit',
          hour: '2-digit',
          minute: '2-digit'
        });
      });
    const dataY = temperaturas.map(t => t.temperatura);

    const option = {
      title: {
        text: 'Temperatura do roteiro ' + this.popupTemperaturaRoteiroService.numeroRoteiro
      },
      tooltip: {
        trigger: 'axis',
        formatter: (params: any) => {
          const ponto = params[0];

          return `
            ${ponto.axisValue}<br/>
            ${ponto.seriesName}: <b>${ponto.value} °C</b>
          `;
        }
      },
      legend: {},
      toolbox: {
      show: true,
      feature: {
        myDownload: {
          show: true,
          title: 'Download Excel',
          icon: 'path://M512 64L512 640M320 448L512 640L704 448M192 768H832',
          onclick: () => {
            this.downloadExcel(this.popupTemperaturaRoteiroService.temperaturas);
          }
        },
        saveAsImage: {
          show: true,
          title: 'Baixar imagem'
          }
        }
      },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        data: dataX,
        name: 'Data', 
        axisLabel: {
          fontSize: 10,
        },
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          formatter: '{value} °C',
          fontWeight: 'bold',
          fontSize: 14,
        },
      },
      series: [
        {
          name: 'Temperatura',
          type: 'line',
          data: dataY,
          itemStyle: {
            color: '#00B951'
          }
        }
      ]
    };

    if (this.chartInstance) {
      this.chartInstance.setOption(option);
      setTimeout(() => {
        this.chartInstance.resize();
      }, 100);
    }
  }


  private iniciarComponenteBind = () => this.iniciarComponente();
  private destruirComponenteBind = () => this.destruirComponente();

  private redimensionar = () => {
    if (this.chartInstance) {
      this.chartInstance.resize();
    }
  };

  destruirComponente(): void {
    window.removeEventListener('resize', this.redimensionar);
    if (this.chartInstance) {
      this.chartInstance.dispose();
      this.chartInstance = null;
    }
  }

  ngOnDestroy(): void {
    if (this.modalElement) {
      this.modalElement.removeEventListener('show.bs.modal', this.iniciarComponente.bind(this));
      this.modalElement.removeEventListener('hidden.bs.modal', this.destruirComponente.bind(this));
    }
    this.destruirComponente();
  }

  downloadExcel(lista: any[]) {
    const dados = lista.map(item => ({
      Roteiro: item.numeroRoteiro,
      'Temperatura (°C)': item.temperatura,
      'Data/Hora': new Date(item.dataCriacao).toLocaleString('pt-BR')
    }));

    const worksheet = XLSX.utils.json_to_sheet(dados);
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, 'Temperaturas');

    const nomeArquivoTemperatura = `temperatura_roteiro_${this.popupTemperaturaRoteiroService.numeroRoteiro}.xlsx`
    XLSX.writeFile(workbook, nomeArquivoTemperatura);
  }
}
